import { render, staticRenderFns } from "./AppAlertsDashboard.vue?vue&type=template&id=3d72a6f6&scoped=true&"
import script from "./AppAlertsDashboard.vue?vue&type=script&lang=js&"
export * from "./AppAlertsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AppAlertsDashboard.vue?vue&type=style&index=0&id=3d72a6f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d72a6f6",
  null
  
)

export default component.exports